
export const common = {
  nav: {
    quemSomos: 'Quiénes Somos',
    servicos: 'Servicios',
    portfolio: 'Portafolio',
    processo: 'Proceso',
    pedirOrcamento: 'Pedir Presupuesto'
  },
  hero: {
    titulo: 'Quien no aparece,',
    titulo2: 'no vende.',
    subtitulo: 'Agencia especializada en estrategia, redes sociales, branding y producción audiovisual profesional.',
    botaoOrcamento: 'Pedir Presupuesto',
    botaoWhatsapp: 'WhatsApp'
  },
  quemSomos: {
    titulo: 'Transformamos marcas en referencias.',
    texto1: '<strong>Olhar Criativo</strong> es una agencia estratégica enfocada en resultados reales. No solo hacemos posts bonitos — construimos posicionamiento, autoridad y crecimiento sostenible para marcas que quieren dominar su mercado.',
    texto2: 'Combinamos estrategia de marketing digital, producción audiovisual de alto nivel y diseño sofisticado para crear experiencias que convierten seguidores en clientes fieles.'
  },
  servicos: {
    titulo: 'Servicios que generan resultados',
    subtitulo: 'Soluciones completas de marketing y producción creativa para marcas que quieren crecer con estrategia y profesionalismo.',
    gestaoRedes: 'Gestión de Redes Sociales',
    gestaoRedesDesc: 'Estrategia completa para Instagram, Facebook y TikTok. Creamos contenido que genera engagement real, aumenta seguidores cualificados y transforma tu presencia digital en una máquina de ventas.',
    producaoConteudo: 'Producción de Contenido',
    producaoConteudoDesc: 'Fotografía y video profesional que elevan la percepción de tu marca. Producimos contenido visual de alto impacto que destaca tu negocio de la competencia y atrae al cliente ideal.',
    designGrafico: 'Diseño Gráfico',
    designGraficoDesc: 'Diseño estratégico que comunica la esencia de tu marca. Creamos identidad visual, materiales gráficos y posts que transmiten profesionalismo y autoridad en cada detalle.',
    branding: 'Branding',
    brandingDesc: 'Construimos marcas memorables desde cero o reposicionamos negocios existentes. Desarrollamos identidad completa, tono de voz y estrategia de posicionamiento que diferencia en el mercado.',
    trafegoPago: 'Tráfico Pago',
    trafegoPagoDesc: 'Campañas de Meta Ads y Google Ads optimizadas para conversión. Invertimos tu presupuesto de forma inteligente para generar leads cualificados y ventas reales, no solo clics.',
    estrategiaDigital: 'Estrategia Digital',
    estrategiaDigitalDesc: 'Planificación completa de marketing digital alineada con tus objetivos de negocio. Analizamos el mercado, definimos metas claras y creamos el camino hacia el crecimiento sostenible.'
  },
  portfolio: {
    titulo: 'Portafolio',
    subtitulo: 'Algunos de nuestros trabajos recientes',
    restaurante: 'Restaurante',
    hamburgueria: 'Hamburguesería',
    steakhouse: 'Steakhouse',
    sushi: 'Sushi',
    spa: 'Spa & Wellness',
    pastelaria: 'Pastelería',
    wine: 'Wine Bar',
    architecture: 'Arquitectura',
  },
  processo: {
    titulo: 'Cómo trabajamos',
    subtitulo: 'Un proceso estructurado y transparente que garantiza resultados predecibles y crecimiento consistente.',
    diagnostico: 'Diagnóstico',
    diagnosticoDesc: 'Analizamos tu negocio, mercado y competencia para identificar oportunidades de crecimiento y puntos de diferenciación.',
    estrategia: 'Estrategia',
    estrategiaDesc: 'Desarrollamos un plan personalizado con objetivos claros, público objetivo definido y tácticas específicas para alcanzar resultados.',
    producao: 'Producción',
    producaoDesc: 'Creamos contenido visual de alto impacto, materiales gráficos profesionales y campañas que captan atención y generan deseo.',
    publicacao: 'Publicación',
    publicacaoDesc: 'Implementamos la estrategia con consistencia, gestionando todas las plataformas y optimizando cada publicación para máximo alcance.',
    crescimento: 'Crecimiento',
    crescimentoDesc: 'Monitorizamos resultados, ajustamos tácticas y escalamos lo que funciona para garantizar crecimiento continuo y sostenible.'
  },
  depoimentos: {
    titulo: 'Lo que dicen nuestros clientes',
    subtitulo: 'Resultados reales de marcas que confiaron en nuestra estrategia y crecieron de forma sostenible.',
    depoimento1: 'Olhar Criativo transformó completamente nuestra presencia digital. En 6 meses, triplicamos el número de reservas provenientes de las redes sociales. Su trabajo es impecable.',
    depoimento2: 'Profesionalismo de principio a fin. El equipo entendió perfectamente nuestra visión y creó una identidad visual que nos diferencia en el mercado. Recomiendo sin dudar.',
    depoimento3: 'Finalmente encontramos una agencia que entrega resultados reales. El ROI de las campañas de tráfico pago superó todas las expectativas. Una asociación para continuar.',
    proprietario: 'Propietario',
    diretora: 'Directora de Marketing',
    ceo: 'CEO'
  },
  formulario: {
    titulo: '¿Listo para crecer?',
    subtitulo: 'Completa el formulario y recibe una propuesta personalizada para transformar la presencia digital de tu negocio.',
    nome: 'Nombre Completo',
    nomePlaceholder: 'Tu nombre',
    empresa: 'Empresa',
    empresaPlaceholder: 'Nombre de la empresa',
    area: 'Área de Negocio',
    areaPlaceholder: 'Selecciona una opción',
    restauracao: 'Restauración',
    hotelaria: 'Hotelería',
    moda: 'Moda',
    beleza: 'Belleza y Bienestar',
    comercio: 'Comercio Local',
    servicosPro: 'Servicios Profesionales',
    outro: 'Otro',
    objetivo: 'Objetivo Principal',
    objetivoPlaceholder: 'Describe lo que quieres lograr (máx. 500 caracteres)',
    orcamento: 'Presupuesto Aproximado',
    telefone: 'Teléfono',
    telefonePlaceholder: '+351 910 000 000',
    enviar: 'Enviar Solicitud de Presupuesto',
    enviando: 'Enviando...',
    sucesso: '✓ ¡Solicitud enviada con éxito! Nos pondremos en contacto pronto.',
    erro: '✗ Error al enviar. Por favor, inténtalo de nuevo.',
    caracteres: 'caracteres'
  },
  footer: {
    descricao: 'Agencia de marketing digital y producción creativa especializada en transformar marcas en referencias del mercado a través de estrategia, diseño y contenido profesional.',
    servicos: 'Servicios',
    contacto: 'Contacto',
    direitos: 'Todos los derechos reservados.'
  }
};
